import { Component, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PaymentMethod, StripeElementsOptions, StripePaymentElementChangeEvent, StripePaymentElementOptions } from '@stripe/stripe-js';
import {
  injectStripe,
  StripeElementsDirective,
  StripePaymentElementComponent,
  StripeFactoryService,
} from 'ngx-stripe';
import { FirebaseFunctionsService } from '../../../services/firebase.functions.service';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Message } from 'primeng/message';

@Component({
    selector: 'app-payments',
    imports: [
        StripeElementsDirective,
        StripePaymentElementComponent,
        ButtonModule,
        ProgressSpinnerModule,
        Message
    ],
    templateUrl: './payments.component.html',
    styleUrl: './payments.component.scss'
})
export class PaymentsComponent implements OnInit {
  firebaseFunctionsService = inject(FirebaseFunctionsService);
  firebaseFirestoreService = inject(FirebaseFirestoreService);
  ngxStripe = injectStripe();
  stripeFactoryService = inject(StripeFactoryService);
  dynamicDialogRef = inject(DynamicDialogRef);

  @Input() openedInDialog = true;
  @Output() paymentAdded = new EventEmitter();
  @Output() paymentMethodChanged = new EventEmitter();

  @ViewChild(StripeElementsDirective) elements!: StripeElementsDirective;

  stripeElementsOptions: StripeElementsOptions = {
    locale: 'en',
    clientSecret: undefined,
    customerSessionClientSecret: undefined,
    appearance: {
      theme: 'stripe',
      variables: {
        colorBackground: '#EEF5EA',
        colorPrimary: '#4D7935'
      }
    }
  };

  paymentElementOptions: StripePaymentElementOptions = {
    layout: {
      type: 'tabs',
      defaultCollapsed: false,
      radios: false,
      spacedAccordionItems: false
    },
    
  };

  savedPaymentMethods: Array<PaymentMethod> = [];
  addNewPaymentButtonProps = {
    show: false,
    enable: false
  }
  loading = true;

  constructor() {
    this.createPaymentSetupIntent();
  }

  async ngOnInit() {}

  async createPaymentSetupIntent() {
    try {
      const data = await this.firebaseFunctionsService.createStripePaymentSetupIntent(this.firebaseFirestoreService.getUserProfile());
      this.stripeElementsOptions = {
        ...this.stripeElementsOptions,
        clientSecret: data?.paymentSetupIntentClientSecret,
        customerSessionClientSecret: data?.customerSessionClientSecret
      } as StripeElementsOptions;

      this.loading = false;
    } catch(error: unknown) {
      this.loading = false;
      console.log(error);
    }
    
  }

  onPaymentChange(data: StripePaymentElementChangeEvent) {
    console.log('onPaymentChange', data)
   this.addNewPaymentButtonProps = {
    show: !data.value.payment_method,
    enable: data.complete
   }
   this.paymentMethodChanged.emit(data.value.payment_method);
  }

  submit() {
    this.elements.submit().subscribe({
      next: async (data) => {
        console.log('success', JSON.stringify(data))
        this.ngxStripe.confirmSetup({
          //`Elements` instance that was used to create the Payment Element
          elements: this.elements._elements,
          confirmParams: {
            return_url: 'http://127.0.0.1:4200/home'
          },
          redirect: 'if_required'
        }).subscribe({
          next: (data) => {
            console.log('confirmed', JSON.stringify(data));
            if(this.openedInDialog) {
              this.dynamicDialogRef.close(data.setupIntent);
            } else {
              this.paymentAdded.emit(data.setupIntent?.payment_method);
            }
          },
          error(err) {
            console.log('confirm error', JSON.stringify(err))
          },
        });
      },
      error(err) {
        console.log('error', JSON.stringify(err))
      },
    });

  }
}
